import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { D151_0 } from 'rpqs/constants/RpqsConstant'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'

const DialogD151_0 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntity] = useState(managementEntity)

    useEffect(() => {
        setEntity(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const rows = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: D151_0.code,
            indicatorName: i18n[D151_0.i18n],
            unit: i18n.hourOrDay,
            onChange: v => setEntity(prev => (updateIndicatorEntity(prev, year, D151_0.code,
                { ...currentEntity?.[D151_0.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntity(updateIndicatorEntity(entityDialog, year, D151_0.code, { ...currentEntity?.[D151_0.code], status }))
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntity}
            codeIndicator={D151_0.code}
        >
            {year && previousYear &&
                <Grid container direction={'column'} gap={2} size={12}>
                    <IndicatorHeaderDialog
                        current={{
                            year,
                            value: managementEntity?.[year]?.[D151_0.code]?.value,
                        }}
                        previous={{
                            year: previousYear,
                            value: managementEntity?.[previousYear]?.[D151_0.code]?.value,
                        }}
                        status={entityDialog?.[year]?.[D151_0.code]?.status}
                        onStatusChange={onStatusChange}
                        unit={i18n.hourOrDay}
                    />
                    <Divider/>
                    <IndicatorTable
                        year={year.toString()}
                        indicators={rows}
                    />

                </Grid>
            }
        </EntityIndicatorDialog>
    )
}

DialogD151_0.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogD151_0
